import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-iqacsubheading-create',
  templateUrl: './iqacsubheading-create.component.html',
  styleUrls: ['./iqacsubheading-create.component.scss']
})
export class IqacsubheadingCreateComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string, private ActivatedRoute: ActivatedRoute, private router: Router,) { }

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  headings = null;
  headingname = null;

  ngOnInit() {
    this.Form = this.formBuilder.group({
      heading: ['', Validators.required],
      subheading: ['', Validators.required],
      headingname: [''],
      _id: [''],
    });
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    this.http.get<any>(this.api_endpoint+'/iqacsubheadingbyid/' + `${id}`).subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              heading: data.data.heading,
              headingname: data.data.headingname,
              subheading: data.data.subheading,
              _id: data.data._id,
            })
          }else{
            this.action = 'Submit';
            this.Form.patchValue({
              heading: '',
              headingname: '',
              subheading: '',
              _id: '',
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  });
  this.http.get<any>(this.api_endpoint+'/iqacheading/').subscribe(
    data => {
      this.headings = data.data
  },
  (err: HttpErrorResponse) => {
    if (err.error instanceof Error) {
      console.log("Client-side error occured.");
    } else {
      console.log("Server-side error occured.");
    }
});
  }

  getheading(value){
    this.http.get<any>(this.api_endpoint+'/iqacheadingbyid/'+value).subscribe(
      data => {
        this.Form.patchValue({
          headingname: data.data.heading,
        })
       
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){
    // console.log(this.Form.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "heading"      : this.Form.value.heading,
        "headingname"      : this.Form.value.headingname,
        "subheading"      : this.Form.value.subheading,
        "admin" : sessionStorage.getItem('adminName'),
        "_id"           : this.Form.value._id,
      };
      this.http.put<any>(this.api_endpoint+'/iqacsubheading', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/iqacsubheading/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "heading"      : this.Form.value.heading,
        "headingname"      : this.Form.value.headingname,
        "subheading"      : this.Form.value.subheading,
        "admin" : sessionStorage.getItem('adminName'),
      };
      this.http.post<any>(this.api_endpoint+'/iqacsubheading', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/iqacsubheading/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
